import { MedicalImagesType } from "../enums/MedicalImagesEnum";
import { SPINESIM_MODALITIES } from "../enums/MedicalImagesEnum";

/**
 * Constants used in the Check module
 */
export const CHECK_CONSTANTS = {
  RADIO_DENSITY_DEFAULTS: {
    DIAMETER: 20,
    HEIGHT: 15,
  },
  VIEW_CLOSE_ANIMATION_TIMEOUT: 500,
};

/**
 * View types that indicate validation views (should trigger refresh)
 */
export const VALIDATION_VIEW_TYPES = [
  MedicalImagesType.LATERAL_VALIDATION_DX,
  MedicalImagesType.FRONT_VALIDATION_DX,
  MedicalImagesType.SAGITTAL_DRR_VALIDATION,
  MedicalImagesType.CORONAL_DRR_VALIDATION,
];

/**
 * Required view types for Check module
 */
export const CHECK_REQUIRED_VIEW_TYPES = [MedicalImagesType.LATERALDX];

/**
 * Mapping of modalities to their allowed view types in Check module
 */
export const MODALITY_ALLOWED_VIEWS = {
  [SPINESIM_MODALITIES.DX]: [
    MedicalImagesType.LATERALDX, // 'LateralDX' - base lateral view
    MedicalImagesType.FRONTDX, // 'FrontDX' - base frontal view
  ],
  [SPINESIM_MODALITIES.CT]: [
    MedicalImagesType.SAGITTAL_CT, // 'Sagittal' - sagittal slice view
    MedicalImagesType.CORONAL_CT, // 'Coronal' - coronal slice view
    MedicalImagesType.AXIAL_CT, // 'Axial' - axial slice view
  ],
  [SPINESIM_MODALITIES.MR]: [
    MedicalImagesType.SAGITTAL_MRI, // 'Sagittal' - sagittal slice view
    MedicalImagesType.CORONAL_MRI, // 'Coronal' - coronal slice view
    MedicalImagesType.AXIAL_MRI, // 'Axial' - axial slice view
  ],
  [SPINESIM_MODALITIES.CT_VOLUME]: [
    MedicalImagesType.VOLUME_CT, // 'Volume' - CT volume rendering
  ],
  [SPINESIM_MODALITIES.MR_VOLUME]: [
    MedicalImagesType.VOLUME_MRI, // 'Volume' - MRI volume rendering
  ],
};
